if (!customElements.get('free-shipping-bar')) {
  customElements.define(
    'free-shipping-bar',
    class FreeShippingBar extends HTMLElement {
      connectedCallback() {
        this.textEl = this.querySelector('[data-fs-text]');
        this.fillEl = this.querySelector('[data-fs-fill]');
        if (!this.textEl || !this.fillEl) return;

        // Shopify.currency.rate converts the store's base currency to the customer's
        // active currency. data-threshold is in the base currency; convert it.
        // data-total (cart.total_price) is already in the active currency.
        this.rate =
          (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
        this.currency = this.dataset.currency || 'USD';
        this.thresholdCents = Math.round((parseInt(this.dataset.threshold, 10) || 0) * this.rate);

        // On the base currency the Liquid-rendered bar is already correct, so there is
        // nothing to recompute on connect. In other currencies, recompute from data-total.
        // (update() can still be called externally — e.g. after a discount change — to
        // refresh the bar for any currency.)
        if (this.rate !== 1) {
          this.update(parseInt(this.dataset.total, 10) || 0);
        }
      }

      // Recompute the fill width and message from a total (in active-currency cents).
      update(totalCents) {
        if (!this.textEl || !this.fillEl || this.thresholdCents <= 0) return;

        if (totalCents >= this.thresholdCents) {
          this.fillEl.style.width = '100%';
          this.textEl.textContent = this.dataset.successText || '';
        } else {
          const remaining = this.thresholdCents - totalCents;
          const percent = Math.min((totalCents / this.thresholdCents) * 100, 100);
          this.fillEl.style.width = `${percent}%`;
          this.textEl.textContent = (this.dataset.progressText || '').replace(
            '[amount]',
            this.formatMoney(remaining, this.currency)
          );
        }
      }

      formatMoney(cents, currency) {
        const amount = cents / 100;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency,
            currencyDisplay: 'narrowSymbol',
          }).format(amount);
        } catch (e) {
          // Fall back to a plain amount if the currency code or narrowSymbol is unsupported.
          return amount.toFixed(2);
        }
      }
    }
  );
}
